import { nestServer } from "@erp/shared/api/axios";
import { getAccessToken } from "@erp/shared/utils/auth/token";
import { getAccessTokenFromRefresh } from "@erp/shared/api/generated/wrappers/auth";
// refresh 단일화용
let refreshPromise = null;
// 드레인 재진입 보호
let isDraining = false;
const waitingQueue = [];
async function _drain() {
    if (isDraining)
        return;
    isDraining = true;
    try {
        while (waitingQueue.length > 0) {
            const item = waitingQueue.shift();
            if (!item)
                continue;
            try {
                const res = await item.task();
                item.resolve(res);
            }
            catch (e) {
                item.reject(e);
            }
        }
    }
    finally {
        isDraining = false;
        if (waitingQueue.length > 0) {
            queueMicrotask(() => {
                void _drain();
            });
        }
    }
}
/**
 * @description Access token 재발급 핸들러
 */
export async function handleReIssueAccessToken(error, originalConfig) {
    // 이 호출의 재시도 결과를 돌려줄 Promise
    const resultPromise = new Promise((resolve, reject) => {
        waitingQueue.push({
            task: async () => {
                originalConfig.headers["Authorization"] = `Bearer ${getAccessToken()}`;
                return nestServer(originalConfig);
            },
            resolve,
            reject,
        });
    });
    // refresh 단일화
    if (!refreshPromise) {
        refreshPromise = getAccessTokenFromRefresh().finally(() => {
            refreshPromise = null;
        });
    }
    try {
        await refreshPromise;
    }
    catch (e) {
        // 재발급 실패 시 대기중 모두 실패 처리
        while (waitingQueue.length > 0) {
            waitingQueue.shift()?.reject(e);
        }
        throw e;
    }
    // 토큰 갱신 후 밀린 요청 실행
    await _drain();
    // 현재 호출의 재시도 결과 반환 (절대 undefined를 반환하지 않음)
    return resultPromise;
}
